import React, { Component } from 'react'
import classes from './Home.module.css'
import InfoBox from '../../Components/Home/InfoBox/InfoBox'
import Courses from '../../Components/Home/Courses/Courses'
import Carousel from '../../Components/Home/Carousel/Carousel'
import Desciption2 from '../../Components/Home/Description/Description2'
import Desciption from '../../Components/Home/Description/Description'
import Review from '../../Components/Home/Review/Review'
import Toolbar from '../../Components/Navigation/Toolbar/Toolbar'
import Footer from '../../Components/Footer/Footer'
import {Redirect} from 'react-router-dom'
class Home extends Component{

    render(){
        return(
            <div>
                {/* <Toolbar/> */}
            <div className={classes.main}>
            <div className={classes.firstSection}>
            <div className={classes.firstSectionCont}>  
            <div className={classes.headingContainer}>
                <p className={classes.heading}>
                Making your study material accessible, excel with us.
                </p>
            <div  className={classes.subHeadingCont}>
                <p className={classes.subHeading}>
                Sign Up for your University 
                Course Material  
                </p>
            </div>
           
                <button className={classes.startBtn}> Start Now</button>
            
            </div>
            <center>
            <div className={classes.InfoBox}>
            <InfoBox/>
            </div>
            </center>
            </div>         
            </div>
            <div>
            <Carousel >
            <div className={classes.Desciption}><Desciption/></div>
            <div className={classes.Desciption}><Desciption2/></div>
            </Carousel>
            </div>
            <Courses/>
            <div>
            <Carousel>
                <div><Review/></div>
                <div><Review/></div>
            </Carousel>
            </div>
            </div>
           
            <Footer/>
          
            </div>
           
        )
    }
}
export default Home
